export default {
  promo: {
    metrics: {
      description_1: 'Эффективность рекомендаций',
      description_2: 'Скорость архитектуры',
      description_3: 'Глубина визуализации'
    }
  }
}
